import React from 'react';
import { Outlet, useMatch } from 'react-router-dom';
import Navbar from '../../components/shared/Navbar';

const Main = () => {
    
    const registerMatch = useMatch('/register')
    const loginMatch = useMatch('/');
    return (
        <div>
            {!loginMatch && !registerMatch && <Navbar />}
            <Outlet />
        </div>
    );
};

export default Main;